import React from "react";
import MachineMeasureComparison from "./MachineMeasureComparison";
import { useMachineMeasure } from "./machineMeasureComparisonHooks";
import { Measure, offgradeMeasures } from "./Types";

export function MachineMeasureComparisonContainer({
  measure,
  title,
}: {
  measure: Measure;
  title: string;
}) {
  const { data, awaitingResponse, myMachines } = useMachineMeasure({
    measure: measure,
  });

  // Offgrade measures keep the filter applied even when below the minimum machine
  // count; instead of an unexplained empty chart we show a "too few data points"
  // message. Other measures revert the filter (handled in useMachineMeasure).
  const isBelowMinimum =
    !!data && data.comparedMachinesCount < data.minimumComparedMachinesCount;
  const showInsufficientDataMessage =
    offgradeMeasures.includes(measure) && isBelowMinimum;

  return (
    <MachineMeasureComparison
      awaitingResponse={awaitingResponse}
      data={data}
      title={title}
      machinesToDisplay={myMachines}
      showInsufficientDataMessage={showInsufficientDataMessage}
      minimumComparedMachinesCount={data?.minimumComparedMachinesCount}
    />
  );
}
